const ActiveStorageAttachmentEntity = (backClient) => ({
  show: async (id) =>
    await backClient.get(`/api/active_storage_attachments/${id}`),
})

export default ActiveStorageAttachmentEntity
